/**
 * MS 인증 만료 신호.
 *
 * refresh 토큰이 없거나 무효라서 MS 액세스 토큰을 되살릴 수 없는 상태를 뜻한다.
 * 이때 포탈 JWT 는 멀쩡하므로 전체 로그아웃 대신 위젯 단위로 재인증을 유도해야 한다.
 * 그러려면 소비 측이 "MS 인증이 죽었다"를 일반 네트워크 오류와 구분할 수 있어야 해서
 * 원본 에러를 감싼 전용 에러로 바꿔 던진다.
 */
export const MS_AUTH_EXPIRED = 'MS_AUTH_EXPIRED';

export type MsAuthExpiredError = Error & {
  code: typeof MS_AUTH_EXPIRED;
  cause?: unknown;
};

export const createMsAuthExpiredError = (
  cause?: unknown,
): MsAuthExpiredError => {
  const error = new Error('MS 인증이 만료되었습니다.') as MsAuthExpiredError;
  error.code = MS_AUTH_EXPIRED;
  error.cause = cause;
  return error;
};

export const isMsAuthExpired = (error: unknown): boolean =>
  !!error &&
  typeof error === 'object' &&
  (error as MsAuthExpiredError).code === MS_AUTH_EXPIRED;
